module.exports = __webpack_public_path__ + "static/media/videoSim.56f68c18.mp4";